import React from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import {
	bookmarkList,
	repoList,
	searchRepoList,
	toastMessage,
} from "../../store";
import { color, flexCenter, flexCenterDir } from "../../style/theme";

const RepoList = () => {
	const [repo, setRepo] = useRecoilState(repoList);
	const [search, setSearch] = useRecoilState(searchRepoList);
	const [message, setMessage] = useRecoilState(toastMessage);
	const [bookmark, setBookmark] = useRecoilState(bookmarkList);

	const resultList = search.length > 0 ? search : repo;

	const bookmarkHandler = (name: string) => {
		if (bookmark.includes(name)) {
			setBookmark(bookmark.filter((item: string) => item !== name));
			setMessage("북마크 삭제되었습니다");
		} else {
			if (bookmark.length < 4) {
				setBookmark([...bookmark, name]);
				setMessage("북마크 추가되었습니다");
			} else if (bookmark.length >= 4) {
				setMessage("최대 4개까지 추가할 수 있습니다");
			}
		}
	};

	return (
		<RepoListSection>
			<div className="head">
				<span className="name">Name</span>
				<span>Fork</span>
				<span>Star</span>
				<span>Language</span>
				<span>Issues</span>
			</div>

			{resultList.map((data: any, idx: number) => (
				<RepoListItem key={data.name}>
					<div className="name">
						<img
							className="bookmark"
							src={`/images/${
								bookmark.includes(data.name) ? "bookmark" : "unbookmark"
							}.svg`}
							alt="Bookmark"
							onClick={() => bookmarkHandler(data.name)}
						/>
						<span>{data.name}</span>
						<span className="visibility">{data.visibility}</span>
						<img
							className="share"
							src={`/images/share.svg`}
							alt="Share"
							onClick={() => window.open(data.html_url)}
						/>
					</div>
					<span>{data.forks_count}</span>
					<span>{data.stargazers_count}</span>
					<span>{data.language}</span>
					<span>{data.open_issues_count}</span>
				</RepoListItem>
			))}
		</RepoListSection>
	);
};

const RepoListSection = styled.ul`
	${flexCenterDir}

	width: 50rem;
	margin: 3rem 0;

	span {
		flex: 1;
		text-align: center;
	}

	.head {
		${flexCenter}

		width: 100%;
		font-size: 1.1rem;
		font-weight: bold;
		background: ${color.subPoint};
		padding: 0.5rem 1rem;
		border-radius: 11px;
	}

	.name {
		flex: 4;
		position: relative;
	}
`;

const RepoListItem = styled.li`
	${flexCenter}

	width: 100%;
	margin-top: 1rem;
	padding: 0.8rem 1rem;
	border-bottom: 1px solid ${color.gray};
	transition: all 0.3s ease 0s;

	img {
		width: 20px;
		margin: 0 0.5rem;
	}

	.bookmark {
		width: 25px;
		border-radius: 4px;
		transition: all 0.3s ease 0s;
		cursor: pointer;

		&:hover {
			box-shadow: 0px 5px 20px ${color.subPoint};
		}
	}

	.share {
		position: absolute;
		right: 0;
		cursor: pointer;
	}

	.visibility {
		border-radius: 8px;
		background: ${color.point};
		padding: 0.3rem 0.5rem;
		margin-left: 0.9rem;
		font-size: 0.8rem;
	}

	&:hover {
		background: ${color.gray};
		box-shadow: 0px 5px 20px ${color.gray};
		transform: translateY(-2px);
		border: none;
		border-radius: 11px;
	}
`;

export default React.memo(RepoList);
